import styled, { css } from 'styled-components';
export var ImageLogo = styled.img.withConfig({
  displayName: "ImageLogo",
  componentId: "sc-y8q8lc-0"
})(["width:28px;height:28px;display:inline-block;border-radius:50%;margin:", "px;border:1px solid #eff0fa;background:#fff;", " ", ""], function (_ref) {
  var space = _ref.space;
  return typeof space === 'undefined' ? '5' : space;
}, function (_ref2) {
  var large = _ref2.large;
  return large && css(["width:36px;height:36px;display:inline-block;"]);
}, function (_ref3) {
  var size = _ref3.size;
  return typeof size !== 'undefined' && css(["width:", "px;height:", "px;"], size, size);
});
export var TextLogo = styled.span.withConfig({
  displayName: "TextLogo",
  componentId: "sc-y8q8lc-1"
})(["background:#c4c9d9;color:#ffffff;font-size:10px;text-align:center;width:28px;height:28px;line-height:28px;display:inline-block;border-radius:50%;letter-spacing:-0.3px;margin:", "px;", " ", ""], function (_ref4) {
  var space = _ref4.space;
  return typeof space === 'undefined' ? '5' : space;
}, function (_ref5) {
  var large = _ref5.large;
  return large && css(["width:36px;height:36px;line-height:32px;border:2px solid white;display:inline-block;"]);
}, function (_ref6) {
  var size = _ref6.size;
  return typeof size !== 'undefined' && css(["width:", "px;height:", "px;line-height:", "px;border:2px solid white;"], size, size, size - 4);
});